import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

export var popoverTheme = function popoverTheme(baseTheme) {
  return _objectSpread({}, popoverArrowTheme(baseTheme), popoverContentTheme(baseTheme), baseTheme);
};
export var popoverArrowTheme = function popoverArrowTheme(baseTheme) {
  return _objectSpread({
    PopoverArrow_backgroundColor: baseTheme.panel_backgroundColor,
    PopoverArrow_borderColor: baseTheme.panel_borderColor
  }, baseTheme);
};
export var popoverContentTheme = function popoverContentTheme(baseTheme) {
  return _objectSpread({
    PopoverContent_backgroundColor: baseTheme.panel_backgroundColor,
    PopoverContent_borderColor: baseTheme.panel_borderColor,
    PopoverContent_borderRadius: baseTheme.borderRadius_1,
    PopoverContent_boxShadow: baseTheme.boxShadow_2,
    PopoverContent_color: baseTheme.color,
    PopoverContent_paddingVertical: baseTheme.space_inset_sm,
    PopoverContent_maxWidth: 'none',
    PopoverContent_zIndex: baseTheme.zIndex_100,
    PopoverContentBlock_marginVertical: baseTheme.space_stack_sm,
    PopoverContentBlock_paddingHorizontal: baseTheme.space_inset_md
  }, baseTheme);
};